// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pSCsZPb5GJG38L {
  position: relative;
  min-height: 36px;
  border-radius: var(--ds-border-radius-200, 8px);
  background-color: var(--ds-surface-raised, #ffffff);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
  color: var(--ds-text, #172b4d);
  cursor: pointer;
  scroll-margin: var(--ds-space-100, 8px);
  padding: var(--ds-space-100, 8px) var(--ds-space-150, 12px) var(--ds-space-0, 0);
}
.pSCsZPb5GJG38L [data-smart-list-jira-card] {
  margin-bottom: var(--ds-space-100, 8px);
}
.o7yv_zpGuGDhv4 {
  display: flex;
}
.hWvI2jDn2DCeJF {
  flex-grow: 1;
  margin-left: var(--ds-space-100, 8px);
}
.PHM_oS7c_GnzB7 {
  display: flex;
  margin-top: var(--ds-space-200, 16px);
}
.viOqRLv77HCLxI {
  width: 50%;
  margin-left: auto;
}
`, ""]);
// Exports
export var skeletonWrapper = `pSCsZPb5GJG38L`;
export var skeletonHeader = `o7yv_zpGuGDhv4`;
export var skeletonSummary = `hWvI2jDn2DCeJF`;
export var skeletonFooter = `PHM_oS7c_GnzB7`;
export var skeletonOpenPreview = `viOqRLv77HCLxI`;
export default ___CSS_LOADER_EXPORT___;
